import React, { PureComponent } from 'react';
import { Player, BigPlayButton, ControlBar, PlaybackRateMenuButton } from 'video-react';

export default class CustomVideoReact extends PureComponent {
  render() {
    return (
      // player_ref (optional) exposes the video-react Player instance so
      // callers can drive playback (seek/play) — e.g. chapter chips.
      <Player playsInline ref={this.props.player_ref} src={this.props.video_url}>
        <BigPlayButton position="center" />
        <ControlBar>
          <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} />
        </ControlBar>
      </Player>
    );
  }
}
